import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import Menu from '../../../common/Menu'
import EmbedBlockOptionsContainer from './EmbedBlockOptionsContainer'
import SourceButton from './SourceButton'
import BlockName from './BlockName'

export const EmbedBlockOptions = ({
  block,
  t
}) => (
  <Fragment>
    {/* Name */}
    <BlockName>{block.name || t('blockOptions.defaultEmbedName')}</BlockName>

    {/* Source */}
    {block.embed.url && <SourceButton source={block.embed.url} />}

    <Menu.Divider />
  </Fragment>
)

EmbedBlockOptions.propTypes = {
  block: PropTypes.object
}

export default EmbedBlockOptionsContainer(EmbedBlockOptions)
